import { useCallback, useState } from "react";
import { ScreenerTransactionsParams } from "@api/token-screener/screener-transactions.ts";
import { getDefaultFilters } from "@providers/token-history-filter/context.ts";
import { MyOrdersFilterContext } from "@providers/my-orders-filter/context.ts";

const MyOrdersFilterProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [filters, setFilters] =
    useState<ScreenerTransactionsParams["filters"]>(getDefaultFilters());

  const onFilterUpdate = useCallback(
    (filters: ScreenerTransactionsParams["filters"]) => {
      setFilters(filters);
    },
    [],
  );

  return (
    <MyOrdersFilterContext.Provider
      value={{ filters, onFiltersUpdate: onFilterUpdate }}
    >
      {children}
    </MyOrdersFilterContext.Provider>
  );
};

export default MyOrdersFilterProvider;
